export { default } from './Arrow';
export type {
    Props,
    Props as ArrowButtonProps,
    LinkButtonProps as ArrowLinkButtonProps
} from '../Button';
